"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPrinter = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconPrinter = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M15.602 7.938v-3.1h-8.2v3.1h-2.15v-5.25h12.5v5.25h-2.15Zm1.22 5.15c.342 0 .634-.124.875-.374.242-.25.363-.546.363-.888 0-.342-.12-.633-.36-.875a1.204 1.204 0 0 0-.89-.363c-.333 0-.625.12-.875.36s-.375.536-.375.89c0 .334.125.626.375.876s.546.374.887.374Zm-1.22 6.143v-3.07h-8.2v3.07h8.2Zm2.15 2.15h-12.5v-3.85H1.141v-6.442c0-.876.308-1.62.926-2.232a3.045 3.045 0 0 1 2.224-.919h14.423c.875 0 1.618.307 2.23.92.613.612.92 1.355.92 2.23v6.443h-4.112v3.85Zm1.962-6v-4.283c0-.29-.094-.53-.28-.722a.931.931 0 0 0-.695-.287H4.29a.967.967 0 0 0-.713.287.967.967 0 0 0-.287.713v4.292h1.961v-1.37h12.5v1.37h1.962Z"
}));
exports.IconPrinter = IconPrinter;
//# sourceMappingURL=IconPrinter.js.map